import { render, staticRenderFns } from "./TravelServiceNewView.vue?vue&type=template&id=d85cade6&scoped=true&"
import script from "./TravelServiceNewView.vue?vue&type=script&lang=js&"
export * from "./TravelServiceNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85cade6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d85cade6')) {
      api.createRecord('d85cade6', component.options)
    } else {
      api.reload('d85cade6', component.options)
    }
    module.hot.accept("./TravelServiceNewView.vue?vue&type=template&id=d85cade6&scoped=true&", function () {
      api.rerender('d85cade6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/travel-service/TravelServiceNewView.vue"
export default component.exports